var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpinnerBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM7.50017 12.7943C10.424 12.7943 12.7943 10.424 12.7943 7.50017C12.7943 4.57631 10.424 2.20605 7.50017 2.20605C4.57631 2.20605 2.20605 4.57631 2.20605 7.50017C2.20605 10.424 4.57631 12.7943 7.50017 12.7943Z",
    fill: "#C7DDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4142 0.589319C11.2531 0.943066 12.0176 1.44533 12.6725 2.06904C13.1137 2.48924 13.0232 3.18968 12.5429 3.56453C12.0628 3.93919 11.3758 3.84286 10.9102 3.45039C9.98901 2.67394 8.79923 2.20606 7.50017 2.20606C4.57631 2.20606 2.20606 4.57631 2.20606 7.50017C2.20606 10.424 4.57631 12.7943 7.50017 12.7943C7.5666 12.7943 7.62165 12.8468 7.62316 12.9132L7.6455 13.8952C7.65936 14.5043 7.17442 15.0177 6.5699 14.9421C5.67248 14.8299 4.79965 14.556 3.99475 14.1305C2.86354 13.5325 1.90414 12.655 1.20781 11.5815C0.511477 10.508 0.101377 9.27416 0.0165145 7.99741C-0.0683478 6.72067 0.17485 5.44344 0.722975 4.28723C1.2711 3.13101 2.10592 2.13426 3.14804 1.39178C4.19015 0.649298 5.40489 0.185784 6.67672 0.0453254C7.94855 -0.095133 9.23516 0.0921358 10.4142 0.589319Z",
    fill: "#97BFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinnerBlue);
export default __webpack_public_path__ + "static/media/IconSpinnerBlue.9361b92e81a2c13464625829e0950cb8.svg";
export { ForwardRef as ReactComponent };